import isNil from 'lodash/isNil';

import {
  durationToMinutes,
  formatMinutesAsHoursAndMinutes,
  minutesToDuration,
} from '~/utils/date/duration';
import { MedicaidThresholdsResponse } from '~/services/api/clinic/types';
import Features from '~/ui/constants/features';
import { IInitialValues } from '../Form/types';

type IThresholdFields = IInitialValues['medicaidThresholds'];

export const NOT_SET = '-';

const toRequestValue = (value: number | string | null): number | null =>
  isNil(value) || String(value).trim() === '' ? null : Number(value);

const toFieldValue = (value?: number | null): string => (isNil(value) ? '' : String(value));

const toDurationField = (minutes?: number | null): string =>
  isNil(minutes) ? '' : minutesToDuration(minutes);

export const formatThresholdsToFields = (
  thresholds?: MedicaidThresholdsResponse,
): IThresholdFields => ({
  monthlyCurrencyThreshold: toFieldValue(thresholds?.monthlyCurrencyThreshold),
  monthlyMinutesThreshold: toDurationField(thresholds?.monthlyMinutesThreshold),
});

export const formatThresholdsToRequest = (
  fields: IThresholdFields,
): MedicaidThresholdsResponse => ({
  monthlyCurrencyThreshold: toRequestValue(fields?.monthlyCurrencyThreshold),
  monthlyMinutesThreshold: durationToMinutes(fields?.monthlyMinutesThreshold ?? ''),
});

export const formatClinicThresholdsToRequest = (
  features: IInitialValues['features'],
  fields: IThresholdFields,
): MedicaidThresholdsResponse | undefined =>
  features?.[Features.MEDICAID] ? formatThresholdsToRequest(fields) : undefined;

export const formatDollarThreshold = (value?: number | null): string =>
  isNil(value)
    ? NOT_SET
    : `$ ${value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

export const formatHoursThreshold = (minutes?: number | null): string =>
  isNil(minutes) ? NOT_SET : formatMinutesAsHoursAndMinutes(minutes);
